/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiTransactionCsvExportRequest,
  ApiTransactionIdsRequest,
  ApiTransactionPagedRequest,
  AvailableAccountsDto,
  AvailableBalanceReport,
  BalanceHistoryReport,
  BulkUpdateTransactionsResponse,
  CashflowHistoryReport,
  DeleteTransactionsResponse,
  DonutChartResponse,
  DonutChartWidgetPayload,
  GatewayBulkUpdateTransactionsRequest,
  GatewayDeleteTransactionsRequest,
  GatewayDuplicatesHandleRequest,
  GetBalanceHistoryReportParams,
  GetCashflowHistoryReportParams,
  ImportResponse,
  LineChartWidgetPayload,
  LineChartWidgetResponse,
  OpenBankingTransactionDetailDto,
  OpenBankingTransactionDto,
  OrderedBarChartResponse,
  OrderedBarChartWidgetPayload,
  OrganisationUserSettingsDto,
  OverviewAccounts,
  PaginatedResponseListOpenBankingTransactionDtoTransactionPagedMeta,
  StartImportParams,
  StartImportPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiDataInsightsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name OrderedBarChartWidget
   * @request POST:/api/v1/data-insights/widgets/ordered-bar-chart
   */
  orderedBarChartWidget = (data: OrderedBarChartWidgetPayload, params: RequestParams = {}) =>
    this.http.request<OrderedBarChartResponse, any>({
      path: `/v1/data-insights/widgets/ordered-bar-chart`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static orderedBarChartWidgetPath = '/v1/data-insights/widgets/ordered-bar-chart'
  static orderedBarChartWidgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name LineChartWidget
   * @request POST:/api/v1/data-insights/widgets/line-chart
   */
  lineChartWidget = (data: LineChartWidgetPayload, params: RequestParams = {}) =>
    this.http.request<LineChartWidgetResponse, any>({
      path: `/v1/data-insights/widgets/line-chart`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static lineChartWidgetPath = '/v1/data-insights/widgets/line-chart'
  static lineChartWidgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name DonutChartWidget
   * @request POST:/api/v1/data-insights/widgets/donut-chart
   */
  donutChartWidget = (data: DonutChartWidgetPayload, params: RequestParams = {}) =>
    this.http.request<DonutChartResponse, any>({
      path: `/v1/data-insights/widgets/donut-chart`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static donutChartWidgetPath = '/v1/data-insights/widgets/donut-chart'
  static donutChartWidgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetOpenBankingTransactionsPost
   * @request POST:/api/v1/data-insights/transactions/paged
   */
  getOpenBankingTransactionsPost = (data: ApiTransactionPagedRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseListOpenBankingTransactionDtoTransactionPagedMeta, any>({
      path: `/v1/data-insights/transactions/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getOpenBankingTransactionsPostPath = '/v1/data-insights/transactions/paged'
  static getOpenBankingTransactionsPostMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name StartImport
   * @request POST:/api/v1/data-insights/transactions/import
   */
  startImport = (query: StartImportParams, data: StartImportPayload, params: RequestParams = {}) =>
    this.http.request<ImportResponse, any>({
      path: `/v1/data-insights/transactions/import`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static startImportPath = '/v1/data-insights/transactions/import'
  static startImportMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name IdsForFilter
   * @request POST:/api/v1/data-insights/transactions/ids
   */
  idsForFilter = (data: ApiTransactionIdsRequest, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/data-insights/transactions/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static idsForFilterPath = '/v1/data-insights/transactions/ids'
  static idsForFilterMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetDuplicatesByOrganisationAndId
   * @request POST:/api/v1/data-insights/transactions/duplicates/handle
   */
  getDuplicatesByOrganisationAndId = (
    data: GatewayDuplicatesHandleRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/data-insights/transactions/duplicates/handle`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static getDuplicatesByOrganisationAndIdPath = '/v1/data-insights/transactions/duplicates/handle'
  static getDuplicatesByOrganisationAndIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name DeleteTransactions
   * @request POST:/api/v1/data-insights/transactions/delete
   */
  deleteTransactions = (data: GatewayDeleteTransactionsRequest, params: RequestParams = {}) =>
    this.http.request<DeleteTransactionsResponse, any>({
      path: `/v1/data-insights/transactions/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static deleteTransactionsPath = '/v1/data-insights/transactions/delete'
  static deleteTransactionsMethod = 'POST'
  /**
   * @description Export transactions by provided filters or selected ids
   *
   * @tags api-data-insights-controller
   * @name OpenBankingTransactionsCsvPost
   * @summary Export transactions to csv
   * @request POST:/api/v1/data-insights/transactions/csv
   */
  openBankingTransactionsCsvPost = (
    data: ApiTransactionCsvExportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/data-insights/transactions/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static openBankingTransactionsCsvPostPath = '/v1/data-insights/transactions/csv'
  static openBankingTransactionsCsvPostMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name BulkUpdate
   * @request POST:/api/v1/data-insights/transactions/bulk-update
   * @deprecated
   */
  bulkUpdate = (data: GatewayBulkUpdateTransactionsRequest, params: RequestParams = {}) =>
    this.http.request<OpenBankingTransactionDto[], any>({
      path: `/v1/data-insights/transactions/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdatePath = '/v1/data-insights/transactions/bulk-update'
  static bulkUpdateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name BulkUpdateExtended
   * @request POST:/api/v1/data-insights/transactions/bulk-update-extended
   */
  bulkUpdateExtended = (data: GatewayBulkUpdateTransactionsRequest, params: RequestParams = {}) =>
    this.http.request<BulkUpdateTransactionsResponse, any>({
      path: `/v1/data-insights/transactions/bulk-update-extended`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateExtendedPath = '/v1/data-insights/transactions/bulk-update-extended'
  static bulkUpdateExtendedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name UpdateSelectedAccounts
   * @request PATCH:/api/v1/data-insights/organisation-user-settings/selectedAccounts
   */
  updateSelectedAccounts = (data: OrganisationUserSettingsDto, params: RequestParams = {}) =>
    this.http.request<OrganisationUserSettingsDto, any>({
      path: `/v1/data-insights/organisation-user-settings/selectedAccounts`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateSelectedAccountsPath =
    '/v1/data-insights/organisation-user-settings/selectedAccounts'
  static updateSelectedAccountsMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name UpdateMossBalanceEnabled
   * @request PATCH:/api/v1/data-insights/organisation-user-settings/mossBalanceEnabled
   */
  updateMossBalanceEnabled = (data: OrganisationUserSettingsDto, params: RequestParams = {}) =>
    this.http.request<OrganisationUserSettingsDto, any>({
      path: `/v1/data-insights/organisation-user-settings/mossBalanceEnabled`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateMossBalanceEnabledPath =
    '/v1/data-insights/organisation-user-settings/mossBalanceEnabled'
  static updateMossBalanceEnabledMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name UpdateCurrency
   * @request PATCH:/api/v1/data-insights/organisation-user-settings/currency
   */
  updateCurrency = (data: OrganisationUserSettingsDto, params: RequestParams = {}) =>
    this.http.request<OrganisationUserSettingsDto, any>({
      path: `/v1/data-insights/organisation-user-settings/currency`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCurrencyPath = '/v1/data-insights/organisation-user-settings/currency'
  static updateCurrencyMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetByOrganisationAndId
   * @request GET:/api/v1/data-insights/transactions/{id}
   */
  getByOrganisationAndId = (id: string, params: RequestParams = {}) =>
    this.http.request<OpenBankingTransactionDetailDto, any>({
      path: `/v1/data-insights/transactions/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByOrganisationAndIdPath = '/v1/data-insights/transactions/${id}'
  static getByOrganisationAndIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetDuplicatesById
   * @request GET:/api/v1/data-insights/transactions/{id}/duplicates
   */
  getDuplicatesById = (id: string, params: RequestParams = {}) =>
    this.http.request<OpenBankingTransactionDto[], any>({
      path: `/v1/data-insights/transactions/${id}/duplicates`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDuplicatesByIdPath = '/v1/data-insights/transactions/${id}/duplicates'
  static getDuplicatesByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetCsvImportTemplate
   * @request GET:/api/v1/data-insights/transactions/import/csv-template
   */
  getCsvImportTemplate = (params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/data-insights/transactions/import/csv-template`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCsvImportTemplatePath = '/v1/data-insights/transactions/import/csv-template'
  static getCsvImportTemplateMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetCashflowHistoryReport
   * @request GET:/api/v1/data-insights/reports/cashflow-history
   */
  getCashflowHistoryReport = (query: GetCashflowHistoryReportParams, params: RequestParams = {}) =>
    this.http.request<CashflowHistoryReport, any>({
      path: `/v1/data-insights/reports/cashflow-history`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCashflowHistoryReportPath = '/v1/data-insights/reports/cashflow-history'
  static getCashflowHistoryReportMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetBalanceHistoryReport
   * @request GET:/api/v1/data-insights/reports/balance-history
   */
  getBalanceHistoryReport = (query: GetBalanceHistoryReportParams, params: RequestParams = {}) =>
    this.http.request<BalanceHistoryReport, any>({
      path: `/v1/data-insights/reports/balance-history`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getBalanceHistoryReportPath = '/v1/data-insights/reports/balance-history'
  static getBalanceHistoryReportMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetAvailableBalanceReport
   * @request GET:/api/v1/data-insights/reports/available-balance
   */
  getAvailableBalanceReport = (params: RequestParams = {}) =>
    this.http.request<AvailableBalanceReport, any>({
      path: `/v1/data-insights/reports/available-balance`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailableBalanceReportPath = '/v1/data-insights/reports/available-balance'
  static getAvailableBalanceReportMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetAvailableOverviewAccounts
   * @request GET:/api/v1/data-insights/reports/available-accounts
   */
  getAvailableOverviewAccounts = (params: RequestParams = {}) =>
    this.http.request<OverviewAccounts, any>({
      path: `/v1/data-insights/reports/available-accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailableOverviewAccountsPath = '/v1/data-insights/reports/available-accounts'
  static getAvailableOverviewAccountsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name FindOrganisationUserSettings
   * @request GET:/api/v1/data-insights/organisation-user-settings
   */
  findOrganisationUserSettings = (params: RequestParams = {}) =>
    this.http.request<OrganisationUserSettingsDto, any>({
      path: `/v1/data-insights/organisation-user-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findOrganisationUserSettingsPath = '/v1/data-insights/organisation-user-settings'
  static findOrganisationUserSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name GetAvailableAccounts
   * @request GET:/api/v1/data-insights/cash-flows/available-accounts
   */
  getAvailableAccounts = (params: RequestParams = {}) =>
    this.http.request<AvailableAccountsDto, any>({
      path: `/v1/data-insights/cash-flows/available-accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailableAccountsPath = '/v1/data-insights/cash-flows/available-accounts'
  static getAvailableAccountsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-data-insights-controller
   * @name DeleteTransactionsByIdAndLinkId
   * @request DELETE:/api/v1/data-insights/transactions/{trxId}/links/{linkId}/delete
   */
  deleteTransactionsByIdAndLinkId = (trxId: string, linkId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/data-insights/transactions/${trxId}/links/${linkId}/delete`,
      method: 'DELETE',
      ...params,
    })

  static deleteTransactionsByIdAndLinkIdPath =
    '/v1/data-insights/transactions/${trxId}/links/${linkId}/delete'
  static deleteTransactionsByIdAndLinkIdMethod = 'DELETE'
}
